import HorizontalScrollArtists from "../components/HorizontalScrollArtists";
import SectionHeader from "../components/SectionHeader";
import HorizontalScrollMediaView from "../components/HorizontalScrollMediaView";
import HomePageMusicGenres from "../components/HomePageMusicGenres";
import Footer from "../components/Footer";
import HomeSliders from "../components/HomeSliders";
import { getPopularAlbumsByStreams } from "../data/albums";
import { getPopularArtistsByStreams } from "../data/artists";
import { getPopularSinglesByStreams } from "../data/singles";

const Home = () => {

  document.title = "Notta";
  
  const popularAlbums = getPopularAlbumsByStreams();
  const popularArtists = getPopularArtistsByStreams();
  const popularSingles = getPopularSinglesByStreams();

  return (
    <div className="pt-[4rem] mx-2 sm:mx-4 md:mx-8 lg:mx-12 xl:mx-16 2xl:mx-20">
      <HomeSliders />
      <HorizontalScrollArtists artists={popularArtists} headTitle="Trending Music Artists" />
      <HorizontalScrollMediaView collection={popularAlbums} headTitle="Top Chart Albums" route="album" />
      <HorizontalScrollMediaView collection={popularSingles} headTitle="Hot Trending Singles" route="single" />
      <SectionHeader title="Explore Popular Genres" showViewAll={true} />
      <HomePageMusicGenres />
      <Footer />
    </div>
  );
};

export default Home;